(function () {
  function wrapSymbols(root) {
    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (node.parentNode && node.parentNode.nodeName === 'SCRIPT') return NodeFilter.FILTER_REJECT;
          if (node.parentNode && node.parentNode.nodeName === 'STYLE') return NodeFilter.FILTER_REJECT;
          if (node.parentNode && node.parentNode.classList && node.parentNode.classList.contains('adese-symbol')) return NodeFilter.FILTER_REJECT;
          return /[\u00AE\u2122]/.test(node.textContent) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      },
      false
    );

    var nodes = [];
    var node;
    while ((node = walker.nextNode())) {
      nodes.push(node);
    }

    nodes.forEach(function (textNode) {
      var wrapper = document.createElement('span');
      wrapper.innerHTML = textNode.textContent
        .replace(/\u00AE/g, '<span class="adese-symbol">®</span>')
        .replace(/\u2122/g, '<span class="adese-symbol">™</span>');
      textNode.parentNode.replaceChild(wrapper, textNode);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      wrapSymbols(document.body);
    });
  } else {
    wrapSymbols(document.body);
  }
})();
